import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import InputWithIcon from './InputWithIcon';
import ClientProvider from './client';
export default createDemo(import.meta.url, InputWithIcon, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/text-fields/demos/input-with-icon/InputWithIcon.tsx",
    "fileName": "InputWithIcon.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport Box from '@mui/material/Box';\nimport Input from '@mui/material/Input';\nimport InputLabel from '@mui/material/InputLabel';\nimport InputAdornment from '@mui/material/InputAdornment';\nimport FormControl from '@mui/material/FormControl';\nimport TextField from '@mui/material/TextField';\nimport AccountCircle from '@mui/icons-material/AccountCircle';\n\nexport default function InputWithIcon() {\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 1,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  const adornmentId = React.useId();\n  const textFieldId = React.useId();\n  const sxId = React.useId();\n  return (\n    <Box sx={{ '& > :not(style)': { m: 1 } }}>\n      <FormControl variant=\"standard\">\n        <InputLabel htmlFor={`${adornmentId}-input`}>\n          With a start adornment\n        </InputLabel>\n        <Input\n          id={`${adornmentId}-input`}\n          startAdornment={\n            <InputAdornment position=\"start\">\n              <AccountCircle />\n            </InputAdornment>\n          }\n        />\n      </FormControl>\n      <TextField\n        id={`${textFieldId}-input`}\n        label=\"TextField\"\n        slotProps={{\n          input: {\n            startAdornment: (\n              <InputAdornment position=\"start\">\n                <AccountCircle />\n              </InputAdornment>\n            ),\n          },\n        }}\n        variant=\"standard\"\n      />\n      <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>\n        <AccountCircle sx={{ color: 'action.active', mr: 1, my: 0.5 }} />\n        <TextField id={`${sxId}-input`} label=\"With sx\" variant=\"standard\" />\n      </Box>\n    </Box>\n  );\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 49,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport Box from '@mui/material/Box';\nimport Input from '@mui/material/Input';\nimport InputLabel from '@mui/material/InputLabel';\nimport InputAdornment from '@mui/material/InputAdornment';\nimport FormControl from '@mui/material/FormControl';\nimport TextField from '@mui/material/TextField';\nimport AccountCircle from '@mui/icons-material/AccountCircle';\n\nexport default function InputWithIcon() {\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 1
        },
        "  const adornmentId = React.useId();\n  const textFieldId = React.useId();\n  const sxId = React.useId();\n  return (\n    <Box sx={{ '& > :not(style)': { m: 1 } }}>\n      <FormControl variant=\"standard\">\n        <InputLabel htmlFor={`${adornmentId}-input`}>\n          With a start adornment\n        </InputLabel>\n        <Input\n          id={`${adornmentId}-input`}\n          startAdornment={\n            <InputAdornment position=\"start\">\n              <AccountCircle />\n            </InputAdornment>\n          }\n        />\n      </FormControl>\n      <TextField\n        id={`${textFieldId}-input`}\n        label=\"TextField\"\n        slotProps={{\n          input: {\n            startAdornment: (\n              <InputAdornment position=\"start\">\n                <AccountCircle />\n              </InputAdornment>\n            ),\n          },\n        }}\n        variant=\"standard\"\n      />\n      <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>\n        <AccountCircle sx={{ color: 'action.active', mr: 1, my: 0.5 }} />\n        <TextField id={`${sxId}-input`} label=\"With sx\" variant=\"standard\" />\n      </Box>\n    </Box>\n  );\n"
      ],
      [
        "span",
        "frame",
        "}\n"
      ]
    ],
    "totalLines": 49,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/Box",
      "@mui/material/Input",
      "@mui/material/InputLabel",
      "@mui/material/InputAdornment",
      "@mui/material/FormControl",
      "@mui/material/TextField",
      "@mui/icons-material/AccountCircle"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
